import React from 'react';

import Container from './container.svg'
import Wedge0Empty from './wedge0-empty.svg'
import Wedge0Full from './wedge0-full.svg'
import Wedge1Empty from './wedge1-empty.svg'
import Wedge1Full from './wedge1-full.svg'
import Wedge2Empty from './wedge2-empty.svg'
import Wedge2Full from './wedge2-full.svg'
import Wedge3Empty from './wedge3-empty.svg'
import Wedge3Full from './wedge3-full.svg'
import Wedge4Empty from './wedge4-empty.svg'
import Wedge4Full from './wedge4-full.svg'
import Wedge5Empty from './wedge5-empty.svg'
import Wedge5Full from './wedge5-full.svg'
import {STANDARD_CATEGORIES_BY_KEY} from "@/lib/constants.mjs";

const Pie = ({ width=100, height=100,
							 entertainment=false,
							 geography=false,
							 sports=false,
							 science=false,
							 history=false,
							 arts=false,
	monotone= false,
	color = '#1D2142',
	className={}
}) => {
	return (
		<svg width={width} height={height} className={className} aria-hidden={true}>
			<Container />
			{entertainment ? <Wedge0Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.entertainment.color} /> : <Wedge0Empty />}
			{geography ? <Wedge1Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.geography.color} /> : <Wedge1Empty />}
			{sports ? <Wedge2Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.sports.color} /> : <Wedge2Empty />}
			{science ? <Wedge3Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.science.color} /> : <Wedge3Empty />}
			{history ? <Wedge4Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.history.color} /> : <Wedge4Empty />}
			{arts ? <Wedge5Full color={monotone ? color : STANDARD_CATEGORIES_BY_KEY.arts.color} /> : <Wedge5Empty />}
		</svg>
	);
};

export default Pie;
